export default {
    activeCustomerOffice: state =>
        state.branchOffices && state.branchOffices.length
            ? state.branchOffices.find(
                  office => office.id === state.selectedOffice
              )
            : null,
    activeCustomerCredit: (state, { activeCustomerOffice }) =>
        activeCustomerOffice && activeCustomerOffice.max_customer_credit
            ? {
                  max_customer_credit: activeCustomerOffice.max_customer_credit,
                  used_customer_credit:
                      activeCustomerOffice.used_customer_credit,
                  available_customer_credit:
                      activeCustomerOffice.max_customer_credit -
                      activeCustomerOffice.used_customer_credit,
                  slack_customer_credit:
                      activeCustomerOffice.slack_customer_credit,
                  slack_customer_credit_amount: activeCustomerOffice.slack_customer_credit
                      ? Math.round(
                            (activeCustomerOffice.max_customer_credit *
                                activeCustomerOffice.slack_customer_credit) /
                                100
                        )
                      : 0,
                  max_available_credit:
                      activeCustomerOffice.max_customer_credit -
                      activeCustomerOffice.used_customer_credit +
                      (activeCustomerOffice.slack_customer_credit
                          ? Math.round(
                                (activeCustomerOffice.max_customer_credit *
                                    activeCustomerOffice.slack_customer_credit) /
                                    100
                            )
                          : 0),
              }
            : null,
    defaultCustomerPchPaymentCondition: (state, getters, rootState) => {
        return rootState.SessionModule.pchPaymentConditions
            ? rootState.SessionModule.pchPaymentConditions.find(
                  cond => cond.id === state.customerPaymentConditionId
              )
            : null
    },
}
